module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 24@2x.df0c615b.png";